import { Pipe, PipeTransform } from '@angular/core';
import cloneDeep from 'lodash.clonedeep';

@Pipe({
  name: 'cloneDeep',
})
export class CloneDeepPipe implements PipeTransform {
  transform<T>(data: T): T {
    return cloneDeep(data);
  }
}
